import * as React from 'react';
import { useSwiper } from 'swiper/react';

const BenefitsCarouselTabs: React.FC<any> = (props: {
	slides: any;
	activeIndex: number;
}) => {
	const swiper = useSwiper();

	return (
		<div className="absolute top-0 z-10 flex w-full flex-col items-center justify-center bg-transparent px-4 pt-24 text-white">
			<p className="!mb-16 !font-rubik text-7xl font-bold">Benefits</p>
			<div className=" flex w-full items-start justify-center gap-10 max-xl:gap-2 max-lg:hidden">
				{props.slides.map((slide: any, i: number) => {
					return (
						<button
							className={`border-t-8 py-2 !font-rubik text-xl font-semibold max-2xl:text-base ${
								i == props.activeIndex - 1
									? 'border-bt-red'
									: 'border-transparent'
							}`}
							onClick={() => swiper.slideTo(i + 1)}
						>
							{slide.title}
						</button>
					);
				})}
			</div>
		</div>
	);
};

export default BenefitsCarouselTabs;
